import type { CanDeactivateFn, UrlTree } from '@angular/router';
import { loginRoutes } from '@capturum/login';
import { Observable } from 'rxjs';

export type CanDeactivateType = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
export interface CanComponentDeactivate {
  canDeactivate: () => CanDeactivateType;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component,
  currentRoute,
  currentState,
  nextState,
) => {
  const [loginPath = 'login', ...otherLoginPaths] = loginRoutes[0].children.map((route) => {
    return route.path;
  });
  const pathIndex = otherLoginPaths.findIndex((path) => {
    return nextState?.url.includes(path);
  });

  if (pathIndex !== -1) {
    return true;
  }

  return component.canDeactivate ? component.canDeactivate() : true;
};
